export interface Comment {
  id: string;
  articleId: string;
  author: string;
  avatarUrl: string;
  content: string;
  level: string;
  publishDate: string;
  likes: number;
}

export const comments: Comment[] = [
  {
    id: 'comment-001',
    articleId: 'article-001',
    author: '资深吃瓜群众老王',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Chinese%20middle-aged%20man%20portrait%2C%20friendly%20face%2C%20warm%20studio%20lighting%2C%20clean%20background%2C%20professional%20headshot%20style&width=120&height=120&seq=chigua-avatar-001&orientation=squarish',
    content: '这个瓜我蹲了好久了！终于有实锤了，之前就觉得这两人不对劲，现在照片都有了，看粉丝还能怎么洗。',
    level: '至尊瓜王',
    publishDate: '2026-06-30',
    likes: 2340,
  },
  {
    id: 'comment-002',
    articleId: 'article-001',
    author: '娱乐圈观察员',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%2C%20stylish%20look%2C%20warm%20studio%20lighting%2C%20clean%20background%2C%20professional%20headshot%20style&width=120&height=120&seq=chigua-avatar-002&orientation=squarish',
    content: '作为圈内人我只能说，这只是冰山一角。后面还有更大的瓜等着呢，各位坐稳了！',
    level: '金牌瓜友',
    publishDate: '2026-06-30',
    likes: 1890,
  },
  {
    id: 'comment-003',
    articleId: 'article-002',
    author: '吃瓜不嫌事大',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%2C%20playful%20expression%2C%20warm%20studio%20lighting%2C%20clean%20background%2C%20professional%20headshot%20style&width=120&height=120&seq=chigua-avatar-003&orientation=squarish',
    content: '哈哈哈笑死我了，这个主播平时装得那么专业，结果一激动全说出来了。录屏已保存，经典永流传！',
    level: '至尊瓜王',
    publishDate: '2026-06-30',
    likes: 3450,
  },
  {
    id: 'comment-004',
    articleId: 'article-004',
    author: '深夜吃瓜人',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20portrait%2C%20elegant%20style%2C%20warm%20studio%20lighting%2C%20clean%20background%2C%20professional%20headshot%20style&width=120&height=120&seq=chigua-avatar-004&orientation=squarish',
    content: '数千万分手费？我酸了。人家的分手费够我打工几辈子了。不过说真的，富豪圈真乱啊。',
    level: '金牌瓜友',
    publishDate: '2026-06-29',
    likes: 1670,
  },
  {
    id: 'comment-005',
    articleId: 'article-007',
    author: '瓜田里的猹',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%2C%20excited%20expression%2C%20warm%20studio%20lighting%2C%20clean%20background%2C%20professional%20headshot%20style&width=120&height=120&seq=chigua-avatar-005&orientation=squarish',
    content: '聊天记录都爆出来了，这下男方跳进黄河也洗不清了。支持女方！出轨只有零次和无数次。',
    level: '至尊瓜王',
    publishDate: '2026-06-27',
    likes: 4560,
  },
  {
    id: 'comment-006',
    articleId: 'article-009',
    author: '正义使者',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20portrait%2C%20serious%20expression%2C%20warm%20studio%20lighting%2C%20clean%20background%2C%20professional%20headshot%20style&width=120&height=120&seq=chigua-avatar-006&orientation=squarish',
    content: '支持所有勇敢发声的女演员！这个圈子早该整顿了，希望有关部门介入调查。这种人就该被封杀！',
    level: '正义瓜友',
    publishDate: '2026-06-26',
    likes: 5120,
  },
];

export function getCommentsByArticleId(articleId: string): Comment[] {
  return comments.filter((c) => c.articleId === articleId);
}